import React from 'react'
import { eventTracking } from '../../utils/Tracking'
import styles from './Pagination.module.css'

interface ComponentProps {
  index: number
  indexOffset?: number
  numberOfItems: number
  setIndex: (index: number) => void
  onBack?: () => void
  sectionTitle: string | undefined
}

function Pagination({
  index = 0,
  setIndex,
  indexOffset = 0,
  numberOfItems,
  onBack,
  sectionTitle,
}: ComponentProps) {
  return (
    <div className={`eo-pagination ${styles.pagination}`}>
      <button
        className={`${styles['pagination-button']} ${styles['pagination-button__back']}`}
        disabled={index === 0 && !onBack}
        onClick={() => {
          if (index + indexOffset === 0 && onBack) {
            onBack()
          } else {
            eventTracking({
              event: 'bp-global-energy-outlook-interaction',
              eventAction: 'click',
              eventCategory: sectionTitle,
              eventLabel: 'Carousel - previous',
              eventUrl: window.location.href,
            })
            setIndex(index - 1)
          }
        }}
      >
        <span>Back</span>
        <img src={`${process.env.PUBLIC_URL}/images/left-arrow.svg`} alt='' />
      </button>

      <div className={styles.indicators}>
        {numberOfItems > -1 &&
          new Array(numberOfItems)
            .fill('')
            .map((_, loopIndex) => (
              <div
                key={loopIndex}
                className={`${styles.indicator} ${
                  styles[
                    index + indexOffset === loopIndex ? 'indicator-active' : ''
                  ]
                }`}
              />
            ))}
      </div>

      <button
        disabled={index + indexOffset === numberOfItems - 1}
        className={`${styles['pagination-button']} ${styles['pagination-button__next']}`}
        onClick={() => {
          if (index + indexOffset < numberOfItems) {
            eventTracking({
              event: 'bp-global-energy-outlook-interaction',
              eventAction: 'click',
              eventCategory: sectionTitle,
              eventLabel: 'Carousel - next',
              eventUrl: window.location.href,
            })
            setIndex(index + 1)
          }
        }}
      >
        <span>Next</span>
        <img src={`${process.env.PUBLIC_URL}/images/right-arrow.svg`} alt='' />
      </button>
    </div>
  )
}

export default Pagination
